import { render, staticRenderFns } from "./battle_open.vue?vue&type=template&id=10787407&scoped=true&"
import script from "./battle_open.vue?vue&type=script&lang=js&"
export * from "./battle_open.vue?vue&type=script&lang=js&"
import style0 from "./battle_open.vue?vue&type=style&index=0&id=10787407&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10787407",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10787407')) {
      api.createRecord('10787407', component.options)
    } else {
      api.reload('10787407', component.options)
    }
    module.hot.accept("./battle_open.vue?vue&type=template&id=10787407&scoped=true&", function () {
      api.rerender('10787407', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/battle/battle_detail/battle_open.vue"
export default component.exports